import React, { PureComponent } from 'react';
import {
    FlatList
} from 'react-native';

import RecordItem from './item';
import NoMore from './no-more';

import { pt } from '../../common/utils';

export default class extends PureComponent {
    state = {
        page: 1,
        pageSize: 30,
        isLoading: false,
        isMore: false,
        recordList: []
    }

    init = (isMore) => {
        const { onFetchList } = this.props;

        const { page, pageSize } = this.state;

        if (!isMore) {
            this.setState({
                isLoading: true
            });
        }

        onFetchList && onFetchList({ page, pageSize })
            .then((res) => {
                // res.errCode 为0 表示成功
                let isError = false;

                if (res?.errCode === null || res?.errCode === undefined || res?.errCode === '') {
                    isError = true;
                } else if (parseInt(res.errCode) === 0) { // 成功
                    isError = false;
                    this.setState((preState) => {
                        return {
                            isLoading: false,
                            isMore: false,
                            recordList: isMore ? [...preState.recordList, ...res?.data?.list] : res?.data?.list
                        };
                    });
                } else {
                    isError = true;
                }

                if (isError) {
                    this.setState({
                        isLoading: false,
                        isMore: false
                    });
                }
            }).catch(() => {
                this.setState({
                    isLoading: false,
                    isMore: false
                });
            });
    }

    componentDidMount() {
        this.init();
    }

    onEndReached = () => {
        const { isLoading, isMore, recordList } = this.state;
        // 表示小于一屏时， 不会加载更多

        if (recordList.length > 8 && !isLoading && !isMore) {
            this.setState((prevState) => {
                return {
                    isMore: true,
                    page: prevState.page + 1
                };
            }, () => {
                this.init(true);
            });
        }
    }

    render() {
        const { recordList, isMore } = this.state;

        const contentContainerStyle = recordList.length > 8 ? { width: pt(375) } : { flex: 1, width: pt(375) };

        return (
            <FlatList
                showsVerticalScrollIndicator={ false }
                contentContainerStyle={ contentContainerStyle }
                style={ { flex: 1, width: pt(375) } }
                keyExtractor={ (item, index) => index + '' }
                data={ recordList }
                onEndReachedThreshold={ 0.2 }
                onEndReached={ this.onEndReached }
                renderItem={ ({ item }) => (<RecordItem item={ item } />) }
                ListFooterComponent={ recordList.length && <NoMore contentText={ isMore ? '加载中...' : '没有更多记录' } /> }
                ListEmptyComponent={ <NoMore contentText='暂无记录' /> }
            />
        );
    }
}
